import React from 'react';
import styled, { css } from 'styled-components';
import { ReactComponent as IconErrorSVG } from '../../../assets/icons/icon_error.svg';
import { ReactComponent as IconCheckSVG } from '../../../assets/icons/icon_check.svg';

const IconError = styled(IconErrorSVG)<{ $isValidate?: boolean | null }>`
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translate(0%, -50%);
  transition: all 0.5s ease-out;
  path {
    fill: #f16464;
  }

  ${(props) => {
    if (props.$isValidate === false) {
      return css`
        display: block;
      `;
    }
    return css`
      display: none;
    `;
  }}
`;
const IconCheck = styled(IconCheckSVG)<{ $isValidate?: boolean | null }>`
  width: 24px;
  height: 18px;
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translate(0%, -50%);

  path {
    fill: #47c1c3;
  }

  ${(props) => {
    if (props.$isValidate) {
      return css`
        display: block;
      `;
    }
    return css`
      display: none;
    `;
  }}
`;

const Component = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const Input = styled.input<{ $height?: number }>`
  font-family: 'RobotoR', 'NotoKrR';
  line-height: normal;
  font-size: 16px;
  border-radius: 8px;
  width: 100%;
  height: ${(props) => props.$height || 56}px;
  background-color: white;
  padding: 16px 44px 16px 16px;
  border: solid 1px ${(props) => props.theme.colors.grey400};
  color: ${(props) => props.theme.colors.grey700};
  &:disabled {
    border: solid 1px ${(props) => props.theme.colors.grey300};
    background-color: ${(props) => props.theme.colors.grey100};
    color: ${(props) => props.theme.colors.grey700};
  }
  &::placeholder {
    color: ${(props) => props.theme.colors.grey500};
    border-color: ${(props) => props.theme.colors.grey400};
  }

  &:focus {
    outline: 0;
    border: solid 1px ${(props) => props.theme.colors.grey800};
    color: ${(props) => props.theme.colors.grey800};
  }
`;

const SuccessMessageBox = styled.div<{ $isValidate?: boolean | null }>`
  margin-top: 8px;
  height: 20px;
  font-family: 'RobotoR', 'NotoKrR';
  line-height: normal;
  font-size: 14px;

  color: #47c1c3;
  ${(props) => {
    if (props.$isValidate) {
      return css`
        display: block;
      `;
    }
    return css`
      display: none;
    `;
  }}
`;

const ErrorMessageBox = styled.div<{ $isValidate?: boolean | null }>`
  margin-top: 8px;
  height: 20px;
  font-family: 'RobotoR', 'NotoKrR';
  line-height: normal;
  font-size: 14px;

  color: #f16464;
  ${(props) => {
    if (props.$isValidate === false) {
      return css`
        display: block;
      `;
    }
    return css`
      display: none;
    `;
  }}
`;

interface InputComponentProps {
  placeholder?: string;
  defaultValue?: string;
  height?: number;
  disabled: boolean;
  type: string;
  name: string;
  autoComplete: string;
  isValidate?: boolean | null;
  successMessage?: string;
  errorMessage?: string;
  value: string;

  onChangeFunc?: (value: string) => void;
}

const InputComponent = ({
  placeholder,
  disabled,
  type,
  name,
  autoComplete,
  isValidate,
  successMessage,
  errorMessage,
  height,
  value,
  defaultValue,

  onChangeFunc,
}: InputComponentProps) => {
  const onChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChangeFunc) {
      onChangeFunc(event.target.value);
    }
  };
  return (
    <Component>
      <InputWrapper>
        <Input
          $height={height}
          autoComplete="no"
          // name={name}
          type={type}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          defaultValue={defaultValue || ''}
          onChange={onChangeInput}
        />
        <IconCheck $isValidate={isValidate} />
        <IconError $isValidate={isValidate} />
      </InputWrapper>
      <SuccessMessageBox $isValidate={isValidate}>
        {successMessage}
      </SuccessMessageBox>
      <ErrorMessageBox $isValidate={isValidate}>{errorMessage}</ErrorMessageBox>
    </Component>
  );
};

export default InputComponent;
